import React, {useEffect, useRef, useState} from 'react';
import {UseLoader} from "../../../hooks/useLoader";
import {Toast} from 'primereact/toast';
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import PropTypes from "prop-types";

import {editarAsociado, selectAsociados} from "../../../api/asociado.service";
import {error} from "../../../shared/utils/utils";
import { confirmDialog } from 'primereact/confirmdialog';


export const ModalEditarAsociado = ({show, hide, fields}) => {
    const [handleLoad] = UseLoader();
    const toast = useRef(null);
    const [afp, setAfp] = useState([]);
    const [eps, setEps] = useState([]);
    const [tipoCuenta, setTipoCuenta] = useState([]);
    const [tipoDoc, setTipoDoc] = useState([]);
    const [banco, setBanco] = useState([]);


    const initParams =  {
        afp_id: "",
        banco_id: "",
        email: "",
        eps_id: "",
        estado: "",
        login: "",
        num_cuenta: "",
        num_doc: "",
        pensionado: "",
        primer_apellido: "",
        primer_nombre: "",
        segundo_apellido: "",
        segundo_nombre: "",
        tipocuenta_id: "",
        tipodoc_id: "",
        usuario_id: "",
        asociado_id: "",
        password: "",
        password2: ""
    };
    // campos
    const [field, setField] = useState(initParams);

    const getSelect = async () => {
        try {
            const response = await selectAsociados();
            return await response.data;
        } catch (e) {
            console.log(e)
        }
    }

    const onSubmit = async (e) => {
        try {
            e.preventDefault();

            const payload = {
                asociado_id: field.asociado_id,
                nombre: field.primer_nombre,
                segundoNombre:field.segundo_nombre,
                primerApellido: field.primer_apellido,
                segundoApellido: field.segundo_apellido,
                afp: field.afp_id,
                banco: field.banco_id,
                eps: field.eps_id,
                estado: field.estado,
                tipoDoc: field.tipodoc_id,
                tipoCuenta: field.tipocuenta_id,
                email: field.email,
                numCuen: field.num_cuenta,
                numDoc: field.num_doc,
                usuario: field.login,
                usuario_id: field.usuario_id,
                password: field.password,
                password2: field.password2,
                pensionado: field.pensionado
            }

            if (payload.nombre === ''
                || payload.primerApellido === ''
                || payload.afp === ''
                || payload.eps === ''
                || payload.estado === ''
                || payload.tipoDoc === ''
                || payload.tipoCuenta === ''
                || payload.email === ''
                || payload.numCuen === ''
                || payload.numDoc === ''
                || payload.usuario === ''
                || payload.usuario_id === ''
            ) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Alerta',
                    detail: "Validar campos",
                    life: 3000
                });
                return;
            }

            if (payload.password != payload.password2) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Alerta',
                    detail: "Contraseñas diferentes",
                    life: 3000
                });
                return;
            }

            if (parseInt(payload.usuario_id) === 0 ) {
                if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*{}-])(?=.{8,30})/i.test(payload.password)) {
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Alerta',
                        detail: "Formato incorrecto (debe tener al menos una mayuscula, número y un caracter especial)",
                        life: 3000
                    });
                    return;
                }
            }

            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoad(true)
                    payload.usuario_id = field.usuario_id;
                    payload.asociado_id = field.asociado_id;
                    const response = await editarAsociado(payload);
                    const data = await response.data;
                    handleLoad(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity: 'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            });
        } catch (e) {
            handleLoad(false)
            console.log(e)
        }
    }



    useEffect(() => {
        if (show) {
            getSelect().then(r => {
                if (r.estado === 200) {
                    const data = r.data;
                    setAfp(data.afp);
                    setEps(data.eps);
                    setTipoCuenta(data.tipoCuenta);
                    setTipoDoc(data.tipoDoc);
                    setBanco(data.banco)
                } else {
                    toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                    return;
                }
            });

        }
        return () => {
            setAfp([]);
            setEps([]);
            setTipoCuenta([]);
            setTipoDoc([]);
            setBanco([])
        };
    }, [show]);

    useEffect(() => {
        setField({
            afp_id: fields.afp_id,
            banco_id: fields.banco_id,
            email: fields.email,
            eps_id: fields.eps_id,
            estado: fields.estado,
            login: fields.login,
            num_cuenta: fields.num_cuenta,
            num_doc: fields.num_doc,
            pensionado: fields.pensionado,
            primer_apellido: fields.primer_apellido,
            primer_nombre: fields.primer_nombre,
            segundo_apellido: fields.segundo_apellido,
            segundo_nombre: fields.segundo_nombre,
            tipocuenta_id: fields.tipocuenta_id,
            tipodoc_id: fields.tipodoc_id,
            usuario_id: fields.usuario_id,
            asociado_id: fields.asociado_id,
            password: "",
            password2: ""
        })

        return () => {
            setField(initParams)
        };
    }, [fields]);



    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Editar afiliado" visible={show} style={{width: '90vw'}}
                   onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={onSubmit} autoComplete="false">
                            <h6 className="title-modal">
                                Información principal
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nombre"
                                    >
                                        Primer nombre *
                                    </label>
                                    <input
                                        id="nombre"
                                        required
                                        maxLength="30"
                                        className="form-input-small"
                                        value={field.primer_nombre}
                                        onChange={(e) => setField({...field, primer_nombre: e.target.value})}
                                    />
                                    {error(field.primer_nombre, 'required')}
                                    {error(field.primer_nombre, 'maxLength', 30)}
                                   {/* {error(field.primer_nombre, 'pattern', 1)}*/}
                                </ContainerGroupForm>


                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="segundoNombre"
                                    >
                                        Segundo nombre
                                    </label>
                                    <input
                                        type="text"
                                        maxLength="30"
                                        className="form-input-small"
                                        id="segundoNombre"
                                        value={field.segundo_nombre}
                                        onChange={(e) => setField({...field, segundo_nombre: e.target.value})}
                                    />
                                    {error(field.segundo_nombre, 'maxLength', 30)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="primerApellido"
                                    >
                                        Primer apellido *
                                    </label>
                                    <input
                                        required
                                        maxLength="30"
                                        value={field.primer_apellido}
                                        onChange={(e) => setField({...field, primer_apellido: e.target.value})}
                                        type="text"
                                        className="form-input-small"
                                        id="primerApellido"
                                    />
                                    {error(field.primer_apellido, 'required')}
                                    {error(field.primer_apellido, 'maxLength', 30)}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="segundoApellido"
                                    >
                                        Segundo apellido
                                    </label>
                                    <input
                                        type="text"
                                        value={field.segundo_apellido}
                                        maxLength="30"
                                        onChange={(e) => setField({...field, segundo_apellido: e.target.value})}
                                        className="form-input-small"
                                        id="segundoApellido"/>
                                    {error(field.segundo_apellido, 'maxLength', 30)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipoDoc"
                                    >
                                        Tipo documento
                                    </label>
                                    <select
                                        className="form-input-small"
                                        value={field.tipodoc_id}
                                        required
                                        onChange={(e) => setField({...field, tipodoc_id: e.target.value})}
                                        id="tipoDoc">
                                        <option value="">seleccione</option>
                                        {tipoDoc.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>

                                    {error(field.tipodoc_id, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="NumDoc"
                                    >
                                        Numero de documento
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        maxLength="15"
                                        className="form-input-small"
                                        value={field.num_doc}
                                        onChange={(e) => setField({...field, num_doc: e.target.value})}
                                        id="NumDoc"/>

                                    {error(field.num_doc, 'required')}
                                    {error(field.num_doc, 'maxLength', 20)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="email"
                                    >
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        maxLength="150"
                                        className="form-input-small"
                                        value={field.email}
                                        onChange={(e) => setField({...field, email: e.target.value})}
                                        id="email"/>
                                    {error(field.email, 'required')}
                                    {error(field.email, 'maxLength', 150)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="afp"
                                    >
                                        Afp
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        onChange={(e) => setField({...field, afp_id: e.target.value})}
                                        value={field.afp_id}
                                        id="afp">
                                        <option value="">seleccione</option>
                                        {afp.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {error(field.afp_id, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="eps"
                                    >
                                        Eps
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        value={field.eps_id}
                                        onChange={(e) => setField({...field, eps_id: e.target.value})}
                                        id="eps">
                                        <option value="">seleccione</option>
                                        {eps.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {error(field.eps_id, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="eps"
                                    >
                                        Pensionado
                                    </label>
                                    <select
                                        value={field.pensionado}
                                        required
                                        onChange={(e) => setField({...field, pensionado: e.target.value})}
                                        className="form-input-small"
                                        id="pensionado">
                                        <option value="">seleccione</option>
                                        <option value="S">Si</option>
                                        <option value="N">No</option>
                                    </select>
                                    {error(field.pensionado, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="banco"
                                    >
                                        Banco
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        value={field.banco_id}
                                        onChange={(e) => setField({...field, banco_id: e.target.value})}
                                        id="banco">
                                        <option value="">seleccione</option>
                                        {banco.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {error(field.banco_id, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tipoCuenta"
                                    >
                                        Tipo de cuenta
                                    </label>
                                    <select
                                        required
                                        value={field.tipocuenta_id}
                                        onChange={(e) => setField({...field, tipocuenta_id: e.target.value})}
                                        className="form-input-small"
                                        id="tipoCuenta">
                                        <option value="">seleccione</option>
                                        {tipoCuenta.map((itm, i) => <option key={i} value={itm.id}>{itm.nombre}</option>)}
                                    </select>
                                    {error(field.tipocuenta_id, 'required')}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="NumCuen"
                                    >
                                        Numero de cuenta
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        maxLength="30"
                                        value={field.num_cuenta}
                                        onChange={(e) => setField({...field, num_cuenta: e.target.value})}
                                        className="form-input-small"
                                        id="NumCuen"/>
                                    {error(field.num_cuenta, 'required')}
                                    {error(field.num_cuenta, 'maxLength', 30)}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-3/12">
                                    <label
                                        className="label-form"
                                        htmlFor="eps"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        required
                                        value={field.estado}
                                        onChange={(e) => setField({...field, estado: e.target.value})}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {error(field.estado, 'required')}
                                </ContainerGroupForm>
                            </div>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>

                            <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
                                Informacion para usuario de ingreso
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="usuario"
                                    >
                                        Usuario
                                    </label>
                                    <input
                                        type="text"
                                        required
                                        maxLength="100"
                                        pattern="[A-Za-z]+"
                                        value={field.login}
                                        onChange={(e) => setField({...field, login: e.target.value})}
                                        className="form-input-small"
                                        id="usuario"/>
                                    {error(field.login, 'required')}
                                    {error(field.login, 'maxLength', 100)}
                                    {error(field.login, 'pattern', 1)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="password"
                                    >
                                        Contraseña
                                    </label>
                                    <input
                                        type="password"
                                        placeholder="*********"
                                        maxLength="16"
                                        value={field.password}
                                        onChange={(e) => setField({...field, password: e.target.value})}
                                        className="form-input-small"
                                        id="password"/>
                                    {error(field.password, 'maxLength', 16)}
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="confirmpas"
                                    >
                                        Confirmar contraseña
                                    </label>
                                    <input
                                        onPaste={(e) => e.preventDefault()}
                                        type="password"
                                        placeholder="*********"
                                        maxLength="16"
                                        value={field.password2}
                                        onChange={(e) => setField({...field, password2: e.target.value})}
                                        className="form-input-small"
                                        id="confirmpas"/>
                                    {field.password !== field.password2 &&
                                    <span className="text-red-600 font-bold text-xs">Contraseña errada</span>}
                                    {error(field.password2, 'maxLength', 16)}
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </>
    );
};

ModalEditarAsociado.prototype = {
    show: PropTypes.bool,
    hide: PropTypes.func,
    fields: PropTypes.object
}

ModalEditarAsociado.defaultProps = {
    show: false,
};
